import { useMemo } from 'react';

import { League } from '@/feature/league-hub-sbk/hooks/use-league';
import { useAllLeagues } from '@/feature/lobby-sbk/hooks/use-all-leagues';
import { useNavigationEntries } from '@/feature/lobby-sbk/hooks/use-navigation-entries';
import { findEntryForLeague } from '@/feature/lobby-sbk/utils/navigation-launchpad-utils';

export const useLeaguesWithLiveEvents = () => {
    const { data: entries } = useNavigationEntries();
    const { data: leaguesData } = useAllLeagues();

    return useMemo(() => {
        if (!entries || !leaguesData) {
            return [];
        }

        const leaguesWithLiveEvents: League[] = [];
        leaguesData.forEach(league => {
            if (league.live_event_count === 0) {
                return;
            }
            const match = findEntryForLeague(entries, league.id);
            if (match) {
                leaguesWithLiveEvents.push({ ...league, name: match.subGroup?.label ?? match.entry.label });
            }
        });
        return leaguesWithLiveEvents;
    }, [entries, leaguesData]);
};
